// PrivateRoute.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { authToken } = useContext(AuthContext);
  if (!authToken) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default PrivateRoute;
